module.exports = __webpack_public_path__ + "img/arrow_down.311950eb.svg";